export { Link, type LinkProps } from './Link';
